import { elysiumOrganisationConfigurations, elysiumOrganisations, } from "./elysium.js";
import { brazilGenericInstance, brazilNorthTrust, brazilSouthTrust, brazilTppInstance, } from "./eprs.js";
import { drFinderInternalDashboard, emhaDashboard, emhaDrFinderDashboard, } from "./supersetDashboards.js";
export const guestUserManagingOrgId = "85a2bedf-ff18-4671-a0b9-b6a6cfccbc50";
export const nhsRootOrgId = "d367ad27-d306-4acf-9b06-8f6cef503313";
export const organisations = "8bded722-14d6-45b2-9eba-415f5e1fd698";
const trainingOrganisationsManagingOrgId = "8b2d1d9f-a1fb-4030-9002-302da953f401";
export const cqc = {
    id: "39819ede-2398-4f15-bc25-db0bf4eb80e5",
    name: "Care Quality Commission (Thalamos Dev)",
    address: "CITYGATE, " + "GALLOWGATE, " + "NEWCASTLE UPON TYNE",
    postalCode: "NE1 4PA",
    role: "cqc",
    codes: [{ system: "nhs/ods", code: "8HN02" }],
    dataControllerId: "39819ede-2398-4f15-bc25-db0bf4eb80e5",
    managingOrganisationId: null,
    status: "active",
};
export const cqcConfiguration = {
    id: cqc.id,
    configuration: {
        nhsNumberEnabled: true,
        pdsEnabled: true,
        pdsEndUserOrganisationODSCode: "8HN02",
        gpPracticeDisplayEnabled: true,
        officialGenderDisplayEnabled: true,
        rioEthnicityDisplayEnabled: true,
        enabledForms: [],
        patientStateEnabled: false,
    },
};
export const cqcTraining = {
    id: "ae2030c2-dad6-4764-97b2-6d17ac4c70b8",
    name: "Care Quality Commission (Training) (Thalamos Dev)",
    address: "CITYGATE, " + "GALLOWGATE, " + "NEWCASTLE UPON TYNE",
    postalCode: "NE1 4PA",
    role: "cqc",
    codes: [],
    dataControllerId: "ae2030c2-dad6-4764-97b2-6d17ac4c70b8",
    managingOrganisationId: null,
    status: "active",
    isTrainingOrganisation: true,
};
export const cqcTrainingConfiguration = {
    id: cqcTraining.id,
    configuration: {
        nhsNumberEnabled: true,
        pdsEnabled: true,
        pdsEndUserOrganisationODSCode: "THALAMOS-CQC-TRAINING",
        pdsAllowedPatientNhsNumber: "2222222222",
        gpPracticeDisplayEnabled: true,
        officialGenderDisplayEnabled: true,
        rioEthnicityDisplayEnabled: true,
        enabledForms: [],
        patientStateEnabled: false,
    },
};
export const nhsDigital = {
    id: "11dc1aa2-6e5e-40dd-b27a-b8e49e8d5dbb",
    name: "NHS Digital",
    address: "THE LEEDS GOVERNMENT HUB, 7-8 WELLINGTON PLACE, LEEDS",
    postalCode: "LS1 4AP",
    role: "nhs/executive",
    codes: [{ system: "nhs/ods", code: "X26" }],
    dataControllerId: "11dc1aa2-6e5e-40dd-b27a-b8e49e8d5dbb",
    managingOrganisationId: null,
    status: "active",
};
export const thalamos = {
    id: "3ad98789-3b16-404c-adad-e9edfe881d2a",
    name: "Thalamos",
    address: "1 Royal St, London",
    postalCode: "SE1 7LL",
    role: "admin",
    codes: [],
    dataControllerId: "3ad98789-3b16-404c-adad-e9edfe881d2a",
    managingOrganisationId: null,
    status: "active",
};
export const nhsLondon = {
    id: "91ed4e39-d5b8-4ac4-9f7e-f932cecfa655",
    name: "NHS London Commissioning Region",
    address: "1W09, 1ST FLOOR, QUARRY HOUSE, " +
        "QUARRY HILL, " +
        "LEEDS, " +
        "WEST YORKSHIRE",
    postalCode: "LS2 7UE",
    role: "nhs/commissioning-region",
    codes: [{ system: "nhs/ods", code: "Y56" }],
    dataControllerId: "91ed4e39-d5b8-4ac4-9f7e-f932cecfa655",
    managingOrganisationId: nhsRootOrgId,
    status: "active",
};
export const southEastLondonIcb = {
    id: "e347db87-29e0-4fad-9ef7-9057c2038d02",
    name: "NHS South East London Integrated Care Board",
    address: "SOUTHWARK COUNCIL, 160 TOOLEY STREET, LONDON",
    postalCode: "SE1 2QH",
    role: "nhs/icb",
    codes: [{ system: "nhs/ods", code: "QKK" }],
    dataControllerId: "e347db87-29e0-4fad-9ef7-9057c2038d02",
    managingOrganisationId: nhsLondon.id,
    status: "active",
    isUserManagementOrganisation: true,
};
export const bromleyLa = {
    id: "716ac63e-3ae4-4b4f-8bbe-63774ebfb8d1",
    name: "Bromley London Authority",
    address: "CITY HALL, 110 THE QUEENS WALK, LONDON",
    postalCode: "SE1 2AA",
    codes: [{ system: "nhs/ods", code: "720" }],
    role: "nhs/local-authority",
    dataControllerId: southEastLondonIcb.id,
    managingOrganisationId: southEastLondonIcb.id,
    status: "active",
};
export const lambethLa = {
    id: "fe298a06-f15b-4928-8f69-5c93df73c70b",
    name: "Lambeth London Authority",
    address: "CITY HALL, 110 THE QUEENS WALK, LONDON",
    postalCode: "SE1 2AA",
    codes: [{ system: "nhs/ods", code: "708" }],
    role: "nhs/local-authority",
    dataControllerId: southEastLondonIcb.id,
    managingOrganisationId: southEastLondonIcb.id,
    status: "active",
};
export const lewishamLa = {
    id: "6190010e-ce9c-4454-a49f-928a2f07ef5c",
    name: "Lewisham London Authority",
    address: "CITY HALL, 110 THE QUEENS WALK, LONDON",
    postalCode: "SE1 2AA",
    codes: [{ system: "nhs/ods", code: "709" }],
    role: "nhs/local-authority",
    dataControllerId: southEastLondonIcb.id,
    managingOrganisationId: southEastLondonIcb.id,
    status: "active",
};
export const southwarkLa = {
    id: "1eb0b2b5-e8eb-4ab6-96d9-ca13a7789c94",
    name: "Southwark London Authority",
    address: "CITY HALL, 110 THE QUEENS WALK, LONDON",
    postalCode: "SE1 2AA",
    codes: [{ system: "nhs/ods", code: "710" }],
    role: "nhs/local-authority",
    dataControllerId: southEastLondonIcb.id,
    managingOrganisationId: southEastLondonIcb.id,
    status: "active",
};
export const greenwichLa = {
    id: "c99c54ce-317d-49c7-bcd3-4206ae167743",
    name: "Greenwich London Authority",
    address: "CITY HALL, 110 THE QUEENS WALK, LONDON",
    postalCode: "SE1 2AA",
    codes: [{ system: "nhs/ods", code: "703" }],
    role: "nhs/local-authority",
    dataControllerId: southEastLondonIcb.id,
    managingOrganisationId: southEastLondonIcb.id,
    status: "active",
};
export const bexleyLa = {
    id: "b29b10d0-1c08-490b-88fd-486afa74a296",
    name: "London Borough of Bexley",
    address: "CIVIC OFFICES, 2 WATLING STREET, BEXLEYHEATH",
    postalCode: "DA6 7AT",
    codes: [{ system: "nhs/ods", code: "718" }],
    role: "nhs/local-authority",
    dataControllerId: southEastLondonIcb.id,
    managingOrganisationId: southEastLondonIcb.id,
    status: "active",
};
export const slamTrust = {
    id: "86af5908-eca4-4ba6-a9d1-b62308b4807e",
    name: "South London and Maudsley NHS Foundation Trust",
    address: "BETHLEM ROYAL HOSPITAL, MONKS ORCHARD ROAD, BECKENHAM, KENT",
    postalCode: "BR3 3BX",
    codes: [{ system: "nhs/ods", code: "RV5" }],
    role: "nhs/trust",
    dataControllerId: southEastLondonIcb.id,
    managingOrganisationId: southEastLondonIcb.id,
    status: "active",
    hasPatientMergeAccess: true,
};
export const oxleasTrust = {
    id: "dff7e30f-57d2-4831-a8ce-daf31ad4bdd9",
    name: "Oxleas NHS Foundation Trust",
    address: "PINEWOOD HOUSE, " + "PINEWOOD PLACE, " + "DARTFORD, " + "DA2 7WG",
    postalCode: "BR3 3BX",
    codes: [{ system: "nhs/ods", code: "RPG" }],
    role: "nhs/trust",
    dataControllerId: southEastLondonIcb.id,
    managingOrganisationId: southEastLondonIcb.id,
    status: "active",
};
export const lewishamAndGreenwichTrust = {
    id: "04e146c7-df30-4b87-824a-d085b0c16516",
    name: "Lewisham and Greenwich NHS Foundation Trust",
    address: "PINEWOOD HOUSE, " + "PINEWOOD PLACE, " + "DARTFORD",
    postalCode: "DA2 7WG",
    codes: [{ system: "nhs/ods", code: "RJ2" }],
    role: "nhs/trust",
    dataControllerId: southEastLondonIcb.id,
    managingOrganisationId: southEastLondonIcb.id,
    status: "active",
};
export const guysAndStThomasTrust = {
    id: "c018f5e1-8612-4f88-9701-68acc8e42232",
    name: "Guys' and St Thomas's NHS Foundation Trust",
    address: "ST THOMAS' HOSPITAL," + "WESTMINSTER BRIDGE ROAD, " + "LONDON",
    postalCode: "SE1 7EH",
    codes: [{ system: "nhs/ods", code: "RJ1" }],
    role: "nhs/trust",
    dataControllerId: southEastLondonIcb.id,
    managingOrganisationId: southEastLondonIcb.id,
    status: "active",
};
export const kingsCollegeHospitalTrust = {
    id: "a501292f-6a15-4b8f-85cf-faafbcb1eff4",
    name: "King's College Hospital NHS Foundation Trust",
    address: "DENMARK HILL, LONDON",
    postalCode: "SE5 9RS",
    codes: [{ system: "nhs/ods", code: "RJZ" }],
    role: "nhs/trust",
    dataControllerId: southEastLondonIcb.id,
    managingOrganisationId: southEastLondonIcb.id,
    status: "active",
};
export const defaultIcbs = [southEastLondonIcb];
export const defaultLocalAuthorities = [
    bromleyLa,
    bexleyLa,
    greenwichLa,
    southwarkLa,
    lambethLa,
    lewishamLa,
];
const defaultTrusts = [
    slamTrust,
    oxleasTrust,
    lewishamAndGreenwichTrust,
    kingsCollegeHospitalTrust,
    guysAndStThomasTrust,
];
export const maudsleyHospital = {
    id: "5a5ea895-75d4-41dc-b461-6bb1e5708cdf",
    name: "Maudsley Hospital",
    address: "DENMARK HILL, LONDON, GREATER LONDON",
    postalCode: "SE5 8AZ",
    codes: [{ system: "nhs/ods", code: "RV504" }],
    role: "hospital",
    dataControllerId: southEastLondonIcb.id,
    managingOrganisationId: slamTrust.id,
    status: "active",
};
export const bethlemHospital = {
    id: "d02ba075-0586-4d6b-967a-d9a37e91a5e8",
    name: "Bethlem Royal Hospital",
    address: "MONKS ORCHARD ROAD, BECKENHAM, KENT",
    postalCode: "BR3 3BX",
    codes: [{ system: "nhs/ods", code: "RV505" }],
    role: "hospital",
    dataControllerId: southEastLondonIcb.id,
    managingOrganisationId: slamTrust.id,
    status: "active",
};
export const lambethHospital = {
    id: "ecdb8780-301b-4c92-b91d-abf75fc2e43b",
    name: "The Lambeth Hospital",
    address: "108 LANDOR ROAD, LONDON, GREATER LONDON",
    postalCode: "SE5 8AZ",
    codes: [{ system: "nhs/ods", code: "RV502" }],
    role: "hospital",
    dataControllerId: southEastLondonIcb.id,
    managingOrganisationId: slamTrust.id,
    status: "active",
};
export const guysHospital = {
    id: "615b467d-5f90-464e-a974-84ec4f393294",
    name: "Guy's Hospital",
    address: "GREAT MAZE POND, " + "LONDON, " + "GREATER LONDON",
    postalCode: "SE1 9RT",
    codes: [{ system: "nhs/ods", code: "RJ121" }],
    role: "hospital",
    dataControllerId: southEastLondonIcb.id,
    managingOrganisationId: guysAndStThomasTrust.id,
    status: "active",
};
export const stThomasHospital = {
    id: "84938ab9-7245-457f-898a-ad011a07cf95",
    name: "St Thomas's Hospital",
    address: "WESTMINSTER BRIDGE ROAD, " + "LONDON, " + "GREATER LONDON",
    postalCode: "SE1 9RT",
    codes: [{ system: "nhs/ods", code: "RJ122" }],
    role: "hospital",
    dataControllerId: southEastLondonIcb.id,
    managingOrganisationId: guysAndStThomasTrust.id,
    status: "active",
};
export const royalBromptonHospital = {
    id: "d0b688de-5086-4852-9e6b-9fa9ec3ed490",
    name: "Royal Brompton Hospital",
    address: "SYDNEY STREET, " + "LONDON," + "GREATER LONDON",
    postalCode: "SE1 9RT",
    codes: [{ system: "nhs/ods", code: "RJ182" }],
    role: "hospital",
    dataControllerId: southEastLondonIcb.id,
    managingOrganisationId: guysAndStThomasTrust.id,
    status: "active",
};
export const harefieldHospital = {
    id: "58d4e072-97ef-46e9-9753-e70bbae1010f",
    name: "Harefield Hospital",
    address: "HILL END ROAD," + "HAREFIELD, " + "UXBRIDGE",
    postalCode: "SE1 9RT",
    codes: [{ system: "nhs/ods", code: "RJ181" }],
    role: "hospital",
    dataControllerId: southEastLondonIcb.id,
    managingOrganisationId: guysAndStThomasTrust.id,
    status: "active",
};
export const orpingtonHospital = {
    id: "932ee488-eaf4-4122-bcca-39c603e36e3e",
    name: "Orpington Hospital",
    address: "HILL END ROAD," + "HAREFIELD, " + "UXBRIDGE",
    postalCode: "SE1 9RT",
    codes: [{ system: "nhs/ods", code: "RJZ70" }],
    role: "hospital",
    dataControllerId: southEastLondonIcb.id,
    managingOrganisationId: kingsCollegeHospitalTrust.id,
    status: "active",
};
export const kingsCollegeHospital = {
    id: "65c5e162-8067-4549-aae2-945c728365fe",
    name: "King's College Hospital",
    address: "HILL END ROAD," + "HAREFIELD, " + "UXBRIDGE",
    postalCode: "SE1 9RT",
    codes: [{ system: "nhs/ods", code: "RJZ01" }],
    role: "hospital",
    dataControllerId: southEastLondonIcb.id,
    managingOrganisationId: kingsCollegeHospitalTrust.id,
    status: "active",
};
export const princessRoyalHospital = {
    id: "310f8bbf-57bc-4c71-8434-2973131f1ab0",
    name: "Princess Royal University Hospital",
    address: "HILL END ROAD," + "HAREFIELD, " + "UXBRIDGE",
    postalCode: "SE1 9RT",
    codes: [{ system: "nhs/ods", code: "RJZ30" }],
    role: "hospital",
    dataControllerId: southEastLondonIcb.id,
    managingOrganisationId: kingsCollegeHospitalTrust.id,
    status: "active",
};
export const universityHospitalLewisham = {
    id: "0e9e58e6-b4d8-429f-b522-a6acc3c63790",
    name: "University Hospital Lewisham",
    address: "HILL END ROAD," + "HAREFIELD, " + "UXBRIDGE",
    postalCode: "SE1 9RT",
    codes: [{ system: "nhs/ods", code: "RJ224" }],
    role: "hospital",
    dataControllerId: southEastLondonIcb.id,
    managingOrganisationId: lewishamAndGreenwichTrust.id,
    status: "active",
};
export const queenElizabethHospital = {
    id: "d6632802-8d8a-409c-bbcb-9a186834b342",
    name: "Queen Elizabeth Hospital",
    address: "HILL END ROAD," + "HAREFIELD, " + "UXBRIDGE",
    postalCode: "SE1 9RT",
    codes: [{ system: "nhs/ods", code: "RJ231" }],
    role: "hospital",
    dataControllerId: southEastLondonIcb.id,
    managingOrganisationId: lewishamAndGreenwichTrust.id,
    status: "active",
};
export const elthamHospital = {
    id: "bb632802-8d8a-409c-bbcb-9a186834b342",
    name: "Eltham Community Hospital",
    address: "HILL END ROAD," + "HAREFIELD, " + "UXBRIDGE",
    postalCode: "SE1 9RT",
    codes: [{ system: "nhs/ods", code: "RPGHP" }],
    role: "hospital",
    dataControllerId: southEastLondonIcb.id,
    managingOrganisationId: oxleasTrust.id,
    status: "active",
};
export const erithHospital = {
    id: "aa632802-8d8a-409c-bbcb-9a186834b342",
    name: "Erith Hospital",
    address: "HILL END ROAD," + "HAREFIELD, " + "UXBRIDGE",
    postalCode: "SE1 9RT",
    codes: [{ system: "nhs/ods", code: "RPGHL" }],
    role: "hospital",
    dataControllerId: southEastLondonIcb.id,
    managingOrganisationId: oxleasTrust.id,
    status: "active",
};
export const bridgewaysDayHospital = {
    id: "157409b2-224e-40c7-8691-43437e56006d",
    name: "Bridgeways Day Hospital",
    address: "HILL END ROAD," + "HAREFIELD, " + "UXBRIDGE",
    postalCode: "SE1 9RT",
    codes: [{ system: "nhs/ods", code: "RPGCR" }],
    role: "hospital",
    dataControllerId: southEastLondonIcb.id,
    managingOrganisationId: oxleasTrust.id,
    status: "active",
};
export const memorialHospital = {
    id: "157aa9b2-224e-40c7-8691-43437e56006d",
    name: "Memorial Hospital",
    address: "HILL END ROAD," + "HAREFIELD, " + "UXBRIDGE",
    postalCode: "SE1 9RT",
    codes: [{ system: "nhs/ods", code: "RPGAG" }],
    role: "hospital",
    dataControllerId: southEastLondonIcb.id,
    managingOrganisationId: oxleasTrust.id,
    status: "active",
};
export const oxleasHouse = {
    id: "157aa9b2-224e-40c7-8691-aa437e56006d",
    name: "Oxleas House",
    address: "HILL END ROAD," + "HAREFIELD, " + "UXBRIDGE",
    postalCode: "SE1 9RT",
    codes: [{ system: "nhs/ods", code: "RPGAE" }],
    role: "hospital",
    dataControllerId: southEastLondonIcb.id,
    managingOrganisationId: oxleasTrust.id,
    status: "active",
};
export const soad1IndependentOrg = {
    id: "9ec96319-7f55-4b14-aa81-f15e456344da",
    name: "Knit Soad (Org)",
    address: "123 Fake Street",
    postalCode: "BR3 3BX",
    codes: [],
    role: "soad",
    dataControllerId: "9ec96319-7f55-4b14-aa81-f15e456344da",
    managingOrganisationId: cqc.id,
    status: "active",
};
export const soad2IndependentOrg = {
    id: "bebb202f-c7ca-4887-9899-f70565c6bd1c",
    name: "Purl Soad (Org)",
    address: "123 Fake Street",
    postalCode: "BR3 3BX",
    codes: [],
    role: "soad",
    dataControllerId: "bebb202f-c7ca-4887-9899-f70565c6bd1c",
    managingOrganisationId: cqc.id,
    status: "active",
};
export const trainingIsabellaSoadOrg = {
    id: "7ea9b971-f8c9-4b7a-bcce-4802182b6cb5",
    name: "Training Isabella Soad (Org)",
    address: "123 Fake Street",
    postalCode: "BR3 3BX",
    codes: [],
    role: "soad",
    dataControllerId: "7ea9b971-f8c9-4b7a-bcce-4802182b6cb5",
    managingOrganisationId: cqcTraining.id,
    isTrainingOrganisation: true,
    status: "active",
};
export const bobIndependentOrg = {
    id: "8de78b81-7432-4f7a-83eb-7bd9b92b50d9",
    name: "Bob Regular Doctor (Org)",
    address: "123 Fake Street",
    postalCode: "BR3 3BX",
    codes: [],
    role: "independent",
    dataControllerId: "8de78b81-7432-4f7a-83eb-7bd9b92b50d9",
    managingOrganisationId: organisations,
    status: "active",
};
export const bobIndependentOrgConfiguration = {
    id: bobIndependentOrg.id,
    configuration: {
        nhsNumberEnabled: true,
        pdsEnabled: true,
        pdsEndUserOrganisationODSCode: "THALAMOS-S12",
    },
};
// Independent Doctor Organizations for S12
export const independentDoctorOrg1 = {
    id: "04a4c3ec-44ca-47df-8a6f-53d4951f8b86",
    name: "Dr. Amara Okafor (Org)",
    address: "123 Fake Street",
    postalCode: "BR3 3BX",
    codes: [],
    role: "independent",
    dataControllerId: "04a4c3ec-44ca-47df-8a6f-53d4951f8b86",
    managingOrganisationId: organisations,
    status: "active",
};
export const independentDoctorOrg2 = {
    id: "04a4c3ec-44ca-47df-8a6f-53d4951f8b87",
    name: "Dr. James Chen (Org)",
    address: "123 Fake Street",
    postalCode: "BR3 3BX",
    codes: [],
    role: "independent",
    dataControllerId: "04a4c3ec-44ca-47df-8a6f-53d4951f8b87",
    managingOrganisationId: organisations,
    status: "active",
};
export const independentDoctorOrg3 = {
    id: "04a4c3ec-44ca-47df-8a6f-53d4951f8b88",
    name: "Dr. Sarah Williams (Org)",
    address: "123 Fake Street",
    postalCode: "BR3 3BX",
    codes: [],
    role: "independent",
    dataControllerId: "04a4c3ec-44ca-47df-8a6f-53d4951f8b88",
    managingOrganisationId: organisations,
    status: "active",
};
export const independentDoctorOrg4 = {
    id: "04a4c3ec-44ca-47df-8a6f-53d4951f8b89",
    name: "Dr. Rajesh Patel (Org)",
    address: "123 Fake Street",
    postalCode: "BR3 3BX",
    codes: [],
    role: "independent",
    dataControllerId: "04a4c3ec-44ca-47df-8a6f-53d4951f8b89",
    managingOrganisationId: organisations,
    status: "active",
};
export const independentDoctorOrg5 = {
    id: "04a4c3ec-44ca-47df-8a6f-53d4951f8b8a",
    name: "Dr. Fatima Al-Rashid (Org)",
    address: "123 Fake Street",
    postalCode: "BR3 3BX",
    codes: [],
    role: "independent",
    dataControllerId: "04a4c3ec-44ca-47df-8a6f-53d4951f8b8a",
    managingOrganisationId: organisations,
    status: "active",
};
export const independentDoctorOrg6 = {
    id: "04a4c3ec-44ca-47df-8a6f-53d4951f8b8b",
    name: "Dr. Michael O'Brien (Org)",
    address: "123 Fake Street",
    postalCode: "BR3 3BX",
    codes: [],
    role: "independent",
    dataControllerId: "04a4c3ec-44ca-47df-8a6f-53d4951f8b8b",
    managingOrganisationId: organisations,
    status: "active",
};
export const independentDoctorOrg7 = {
    id: "04a4c3ec-44ca-47df-8a6f-53d4951f8b8c",
    name: "Dr. Priya Sharma (Org)",
    address: "123 Fake Street",
    postalCode: "BR3 3BX",
    codes: [],
    role: "independent",
    dataControllerId: "04a4c3ec-44ca-47df-8a6f-53d4951f8b8c",
    managingOrganisationId: organisations,
    status: "active",
};
export const independentDoctorOrg8 = {
    id: "04a4c3ec-44ca-47df-8a6f-53d4951f8b8d",
    name: "Dr. David Thompson (Org)",
    address: "123 Fake Street",
    postalCode: "BR3 3BX",
    codes: [],
    role: "independent",
    dataControllerId: "04a4c3ec-44ca-47df-8a6f-53d4951f8b8d",
    managingOrganisationId: organisations,
    status: "active",
};
export const independentDoctorOrg9 = {
    id: "04a4c3ec-44ca-47df-8a6f-53d4951f8b8e",
    name: "Dr. Aisha Mohammed (Org)",
    address: "123 Fake Street",
    postalCode: "BR3 3BX",
    codes: [],
    role: "independent",
    dataControllerId: "04a4c3ec-44ca-47df-8a6f-53d4951f8b8e",
    managingOrganisationId: organisations,
    status: "active",
};
export const independentDoctorOrg10 = {
    id: "04a4c3ec-44ca-47df-8a6f-53d4951f8b8f",
    name: "Dr. Thomas Anderson (Org)",
    address: "123 Fake Street",
    postalCode: "BR3 3BX",
    codes: [],
    role: "independent",
    dataControllerId: "04a4c3ec-44ca-47df-8a6f-53d4951f8b8f",
    managingOrganisationId: organisations,
    status: "active",
};
export const independentDoctorOrg11 = {
    id: "14a4c3ec-44ca-47df-8a6f-53d4951f8b80",
    name: "Dr. Yuki Tanaka (Org)",
    address: "123 Fake Street",
    postalCode: "BR3 3BX",
    codes: [],
    role: "independent",
    dataControllerId: "14a4c3ec-44ca-47df-8a6f-53d4951f8b80",
    managingOrganisationId: organisations,
    status: "active",
};
export const independentDoctorOrg12 = {
    id: "04a4c3ec-44ca-47df-8a6f-53d4951f8b81",
    name: "Dr. Elena Rodriguez (Org)",
    address: "123 Fake Street",
    postalCode: "BR3 3BX",
    codes: [],
    role: "independent",
    dataControllerId: "04a4c3ec-44ca-47df-8a6f-53d4951f8b81",
    managingOrganisationId: organisations,
    status: "active",
};
export const independentDoctorOrg13 = {
    id: "04a4c3ec-44ca-47df-8a6f-53d4951f8b82",
    name: "Dr. Kwame Mensah (Org)",
    address: "123 Fake Street",
    postalCode: "BR3 3BX",
    codes: [],
    role: "independent",
    dataControllerId: "04a4c3ec-44ca-47df-8a6f-53d4951f8b82",
    managingOrganisationId: organisations,
    status: "active",
};
export const independentDoctorOrg14 = {
    id: "04a4c3ec-44ca-47df-8a6f-53d4951f8b83",
    name: "Dr. Sophie Dubois (Org)",
    address: "123 Fake Street",
    postalCode: "BR3 3BX",
    codes: [],
    role: "independent",
    dataControllerId: "04a4c3ec-44ca-47df-8a6f-53d4951f8b83",
    managingOrganisationId: organisations,
    status: "active",
};
export const independentDoctorOrg15 = {
    id: "04a4c3ec-44ca-47df-8a6f-53d4951f8b84",
    name: "Dr. Ahmed Hassan (Org)",
    address: "123 Fake Street",
    postalCode: "BR3 3BX",
    codes: [],
    role: "independent",
    dataControllerId: "04a4c3ec-44ca-47df-8a6f-53d4951f8b84",
    managingOrganisationId: organisations,
    status: "active",
};
export const independentDoctorOrg1Configuration = {
    id: independentDoctorOrg1.id,
    configuration: {
        section12DoctorFinderEnabled: true,
        section12PaymentsEnabled: true,
        nhsNumberEnabled: true,
        pdsEnabled: true,
        pdsEndUserOrganisationODSCode: "THALAMOS-S12",
    },
};
export const independentDoctorOrg2Configuration = {
    id: independentDoctorOrg2.id,
    configuration: {
        section12DoctorFinderEnabled: true,
        section12PaymentsEnabled: true,
        nhsNumberEnabled: true,
        pdsEnabled: true,
        pdsEndUserOrganisationODSCode: "THALAMOS-S12",
    },
};
export const independentDoctorOrg3Configuration = {
    id: independentDoctorOrg3.id,
    configuration: {
        section12DoctorFinderEnabled: true,
        section12PaymentsEnabled: true,
        nhsNumberEnabled: true,
        pdsEnabled: true,
        pdsEndUserOrganisationODSCode: "THALAMOS-S12",
    },
};
export const independentDoctorOrg4Configuration = {
    id: independentDoctorOrg4.id,
    configuration: {
        section12DoctorFinderEnabled: true,
        section12PaymentsEnabled: true,
        nhsNumberEnabled: true,
        pdsEnabled: true,
        pdsEndUserOrganisationODSCode: "THALAMOS-S12",
    },
};
export const independentDoctorOrg5Configuration = {
    id: independentDoctorOrg5.id,
    configuration: {
        section12DoctorFinderEnabled: true,
        section12PaymentsEnabled: true,
        nhsNumberEnabled: true,
        pdsEnabled: true,
        pdsEndUserOrganisationODSCode: "THALAMOS-S12",
    },
};
export const independentDoctorOrg6Configuration = {
    id: independentDoctorOrg6.id,
    configuration: {
        section12DoctorFinderEnabled: true,
        section12PaymentsEnabled: true,
        nhsNumberEnabled: true,
        pdsEnabled: true,
        pdsEndUserOrganisationODSCode: "THALAMOS-S12",
    },
};
export const independentDoctorOrg7Configuration = {
    id: independentDoctorOrg7.id,
    configuration: {
        section12DoctorFinderEnabled: true,
        section12PaymentsEnabled: true,
        nhsNumberEnabled: true,
        pdsEnabled: true,
        pdsEndUserOrganisationODSCode: "THALAMOS-S12",
    },
};
export const independentDoctorOrg8Configuration = {
    id: independentDoctorOrg8.id,
    configuration: {
        section12DoctorFinderEnabled: true,
        section12PaymentsEnabled: true,
        nhsNumberEnabled: true,
        pdsEnabled: true,
        pdsEndUserOrganisationODSCode: "THALAMOS-S12",
    },
};
export const independentDoctorOrg9Configuration = {
    id: independentDoctorOrg9.id,
    configuration: {
        section12DoctorFinderEnabled: true,
        section12PaymentsEnabled: true,
        nhsNumberEnabled: true,
        pdsEnabled: true,
        pdsEndUserOrganisationODSCode: "THALAMOS-S12",
    },
};
export const independentDoctorOrg10Configuration = {
    id: independentDoctorOrg10.id,
    configuration: {
        section12DoctorFinderEnabled: true,
        section12PaymentsEnabled: true,
        nhsNumberEnabled: true,
        pdsEnabled: true,
        pdsEndUserOrganisationODSCode: "THALAMOS-S12",
    },
};
export const independentDoctorOrg11Configuration = {
    id: independentDoctorOrg11.id,
    configuration: {
        section12DoctorFinderEnabled: true,
        section12PaymentsEnabled: true,
        nhsNumberEnabled: true,
        pdsEnabled: true,
        pdsEndUserOrganisationODSCode: "THALAMOS-S12",
    },
};
export const independentDoctorOrg12Configuration = {
    id: independentDoctorOrg12.id,
    configuration: {
        section12DoctorFinderEnabled: true,
        section12PaymentsEnabled: true,
        nhsNumberEnabled: true,
        pdsEnabled: true,
        pdsEndUserOrganisationODSCode: "THALAMOS-S12",
    },
};
export const independentDoctorOrg13Configuration = {
    id: independentDoctorOrg13.id,
    configuration: {
        section12DoctorFinderEnabled: true,
        section12PaymentsEnabled: true,
        nhsNumberEnabled: true,
        pdsEnabled: true,
        pdsEndUserOrganisationODSCode: "THALAMOS-S12",
    },
};
export const independentDoctorOrg14Configuration = {
    id: independentDoctorOrg14.id,
    configuration: {
        section12DoctorFinderEnabled: true,
        section12PaymentsEnabled: true,
        nhsNumberEnabled: true,
        pdsEnabled: true,
        pdsEndUserOrganisationODSCode: "THALAMOS-S12",
    },
};
export const independentDoctorOrg15Configuration = {
    id: independentDoctorOrg15.id,
    configuration: {
        section12DoctorFinderEnabled: true,
        section12PaymentsEnabled: true,
        nhsNumberEnabled: true,
        pdsEnabled: true,
        pdsEndUserOrganisationODSCode: "THALAMOS-S12",
    },
};
export const acdFacilitatorIndependentOrg = {
    id: "58e5f418-fb1f-48b1-b901-36470d2c8171",
    name: "Mackenzie ACD Facilitator (Org)",
    address: "123 Fake Street",
    postalCode: "BR3 3BX",
    codes: [],
    role: "independent",
    dataControllerId: "58e5f418-fb1f-48b1-b901-36470d2c8171",
    managingOrganisationId: organisations,
    status: "active",
};
export const trainingHospital = {
    id: "3fee05a6-a245-49f4-a7da-470064617994",
    name: "Thalamos Training Hospital",
    address: "1 Royal Street",
    postalCode: "SE1 9RT",
    isTrainingOrganisation: true,
    codes: [],
    role: "hospital",
    dataControllerId: trainingOrganisationsManagingOrgId,
    managingOrganisationId: trainingOrganisationsManagingOrgId,
    status: "active",
};
export const trainingLa = {
    id: "6426f659-e801-4235-829f-d2444a388d54",
    name: "Thalamos Training Local Authority",
    address: "1 Royal Street",
    postalCode: "SE1 9RT",
    isTrainingOrganisation: true,
    codes: [],
    role: "nhs/local-authority",
    dataControllerId: trainingOrganisationsManagingOrgId,
    managingOrganisationId: trainingOrganisationsManagingOrgId,
    status: "active",
};
export const nhsDashboardOrg = {
    id: "df0e7007-10c4-4ec0-baa6-c6d39c0f3dd7",
    name: "NHS Dashboard Org",
    address: "1 Royal Street",
    postalCode: "SE1 9RT",
    role: "nhs/dashboard",
    codes: [],
    dataControllerId: "df0e7007-10c4-4ec0-baa6-c6d39c0f3dd7",
    managingOrganisationId: null,
    status: "active",
};
export const supersetDashboardOrg = {
    id: "e717201d-d758-4bb4-8ab6-07bdcd606bb0",
    name: "Superset Dashboard Org",
    address: "1 Royal Street",
    postalCode: "SE1 9RT",
    role: "superset/dashboard",
    codes: [],
    dataControllerId: "e717201d-d758-4bb4-8ab6-07bdcd606bb0",
    managingOrganisationId: null,
    status: "active",
};
// Leading Edge AMHP Team. Hardcoded rather than imported from teams.ts, which
// imports this module — importing it back would create a circular dependency.
const leadingEdgeAmhpTeamId = "720a93ee-9d13-4a17-8158-ccc255329335";
// Leading Edge Trust. Hardcoded because that organisation is declared further down
// this module, so the export is still in its temporal dead zone here.
const leadingEdgeTrustId = "1c42a327-661c-47d4-ab9d-17b8a883ae88";
export const supersetDashboardOrgConfiguration = {
    id: supersetDashboardOrg.id,
    configuration: {
        embedDashboards: [
            {
                supersetDashboardId: emhaDrFinderDashboard.id,
                rlsRules: [{ type: "team", teamIds: [leadingEdgeAmhpTeamId] }],
            },
            {
                supersetDashboardId: drFinderInternalDashboard.id,
                rlsRules: [],
                noRlsAcknowledged: true,
            },
            {
                supersetDashboardId: emhaDashboard.id,
                rlsRules: [
                    { type: "organisation", organisationIds: [leadingEdgeTrustId] },
                ],
            },
        ],
    },
};
export const acdFacilitatorIndependentOrgConfiguration = {
    id: acdFacilitatorIndependentOrg.id,
    configuration: {
        acdEnabled: true,
        mhaAdmissionsEnabled: false,
    },
};
export const slamDefaultOrgConfiguration = {
    id: slamTrust.id,
    configuration: {
        rioInstancesEnabled: [
            {
                instanceId: brazilNorthTrust.id,
                displayName: brazilNorthTrust.externalSystemName,
            },
        ],
        // patientStateEnabled: true,
        // nhsNumberEnabled: true,
        // pdsEnabled: true,
        // pdsEndUserOrganisationODSCode: "RV5",
    },
};
export const leadingEdgeIcb = {
    id: "1fcad218-a833-466e-b774-c67c4ffbbbf8",
    name: "Leading Edge ICB",
    address: "1 Streets Ahead",
    postalCode: "SE1 9RT",
    isTrainingOrganisation: false,
    codes: [],
    role: "nhs/icb",
    dataControllerId: "1fcad218-a833-466e-b774-c67c4ffbbbf8",
    managingOrganisationId: nhsLondon.id,
    status: "active",
    isUserManagementOrganisation: true,
    hasPatientMergeAccess: true,
};
export const leadingEdgeIcbConfiguration = {
    id: leadingEdgeIcb.id,
    configuration: {
        rioInstancesEnabled: [
            {
                instanceId: brazilNorthTrust.id,
                displayName: brazilNorthTrust.externalSystemName,
            },
        ],
        tppInstancesEnabled: [
            {
                instanceId: brazilTppInstance.id,
                displayName: brazilTppInstance.displayName,
            },
        ],
        genericInstancesEnabled: [
            {
                instanceId: brazilGenericInstance.id,
                displayName: brazilGenericInstance.displayName,
            },
        ],
        patientStateEnabled: true,
        patientListEnabled: true,
        s132RecordingEnabled: true,
        section136MhaStatusCalculationEnabled: true,
        nhsNumberEnabled: true,
        pdsEnabled: true,
        pdsEndUserOrganisationODSCode: "LEAD",
        rafEnabled: true,
        reconciliationViaNhsNumberEnabled: true,
        patientAutoMergeEnabled: true,
        uploadFormsEnabled: true,
        mhaStatusReportEnabled: true,
        pdsBatchTracingEnabled: true,
        phoneticPatientIndexSearchEnabled: true,
        patientDemographicsAlertEmail: "thalamostesting+leading-edge-icb@gmail.com",
        section12DoctorFinderEnabled: true,
        section12PaymentsEnabled: true,
        section12PrecisePaymentsEnabled: true,
        dataControllerWarningEnabled: true,
        deMinimisCorrectionsEnabled: true,
        redoFormsEnabled: true,
        gpPracticeDisplayEnabled: true,
        officialGenderDisplayEnabled: true,
        rioEthnicityDisplayEnabled: true,
        mcaEnabled: true,
        s62Enabled: true,
        tortusAvtDictationEnabled: true,
        tortusAvtFakeDictationEnabled: true,
        mhlAutoRouteConfig: {
            enabledFormTemplates: [
                // Forms without hospital fields - these use org-config routing
                "mha-a3",
                "mha-a4",
                "mha-a7",
                "mha-a8",
                "mha-a11",
                "mha-cto1",
                "mha-cto2",
                "mha-cto9",
                "mha-cto12",
                "mha-s62",
                "mha-t2",
                "mha-t4",
            ],
            teams: [{ teamId: "9dd158cc-d4fe-403d-a915-f592b266751c" }], // Leading Edge MHA Team
        },
    },
};
export const leadingEdgeTrust = {
    id: "1c42a327-661c-47d4-ab9d-17b8a883ae88",
    name: "Leading Edge Trust",
    address: "2 Streets Ahead",
    postalCode: "SE1 9RT",
    isTrainingOrganisation: false,
    codes: [],
    role: "nhs/trust",
    dataControllerId: leadingEdgeIcb.id,
    managingOrganisationId: leadingEdgeIcb.id,
    status: "active",
    hasPatientMergeAccess: true,
};
export const leadingEdgeTrustTwo = {
    id: "2d53b438-772d-48e5-ac0e-28c9b994bf99",
    name: "Leading Edge Trust Two",
    address: "2b Streets Ahead",
    postalCode: "SE1 9RT",
    isTrainingOrganisation: false,
    codes: [],
    role: "nhs/trust",
    dataControllerId: leadingEdgeIcb.id,
    managingOrganisationId: leadingEdgeIcb.id,
    status: "active",
    hasPatientMergeAccess: true,
};
export const leadingEdgeTrustConfiguration = {
    id: leadingEdgeTrust.id,
    configuration: {
        patientDemographicsAlertEmail: "thalamostesting+leading-edge-trust@gmail.com",
    },
};
export const leadingEdgeTrustTwoConfiguration = {
    id: leadingEdgeTrustTwo.id,
    configuration: {
        patientDemographicsAlertEmail: "thalamostesting+leading-edge-trust-two@gmail.com",
    },
};
export const leadingEdgeHospital = {
    id: "c55ced2b-7fd5-4451-89f8-51b1b21fb328",
    name: "Leading Edge Hospital",
    address: "3 Streets Ahead",
    postalCode: "SE1 9RT",
    isTrainingOrganisation: false,
    codes: [],
    role: "hospital",
    dataControllerId: leadingEdgeIcb.id,
    managingOrganisationId: leadingEdgeTrust.id,
    status: "active",
    hasPatientMergeAccess: true,
};
export const leadingEdgeLocalAuthority = {
    id: "0718b0b7-8416-4956-94d0-66cd3fec0572",
    name: "Leading Edge Local Authority",
    address: "4 Streets Ahead",
    postalCode: "SE1 9RT",
    isTrainingOrganisation: false,
    codes: [],
    role: "hospital",
    dataControllerId: leadingEdgeIcb.id,
    managingOrganisationId: leadingEdgeIcb.id,
    status: "active",
    hasPatientMergeAccess: true,
};
export const trailingEdgeIcb = {
    id: "4a78270d-ccde-41d5-a414-f25a1ae6bb9e",
    name: "Trailing Edge ICB",
    address: "1 Streets Behind",
    postalCode: "SE1 9RT",
    isTrainingOrganisation: false,
    codes: [],
    role: "nhs/icb",
    dataControllerId: "4a78270d-ccde-41d5-a414-f25a1ae6bb9e",
    managingOrganisationId: nhsLondon.id,
    status: "active",
};
export const trailingEdgeIcbConfiguration = {
    id: trailingEdgeIcb.id,
    configuration: {
        uploadFormsEnabled: true,
        rioInstancesEnabled: [
            {
                instanceId: brazilNorthTrust.id,
                displayName: brazilNorthTrust.externalSystemName,
            },
        ],
    },
};
export const trailingEdgeTrust = {
    id: "3924b406-6427-4665-ba22-a943b2a80149",
    name: "Trailing Edge Trust",
    address: "2 Streets Behind",
    postalCode: "SE1 9RT",
    isTrainingOrganisation: false,
    codes: [],
    role: "nhs/trust",
    dataControllerId: trailingEdgeIcb.id,
    managingOrganisationId: trailingEdgeIcb.id,
    status: "active",
};
export const trailingEdgeHospital = {
    id: "085c0001-95cf-46b7-93aa-d2ad1cf0700f",
    name: "Trailing Edge Hospital",
    address: "3 Streets Behind",
    postalCode: "SE1 9RT",
    isTrainingOrganisation: false,
    codes: [],
    role: "hospital",
    dataControllerId: trailingEdgeIcb.id,
    managingOrganisationId: trailingEdgeTrust.id,
    status: "active",
};
export const trailingEdgeLocalAuthority = {
    id: "76017d60-8135-4465-a317-1e202b95c2ae",
    name: "Trailing Edge Local Authority",
    address: "4 Streets Behind",
    postalCode: "SE1 9RT",
    isTrainingOrganisation: false,
    codes: [],
    role: "hospital",
    dataControllerId: trailingEdgeIcb.id,
    managingOrganisationId: trailingEdgeIcb.id,
    status: "active",
};
export const dataControllerNorth = {
    id: "166d2b1e-e78f-42f9-9662-5d62bbb10895",
    name: "Data Controller North",
    address: "1 Royal Street",
    postalCode: "SE1 9RT",
    isTrainingOrganisation: false,
    codes: [],
    role: "nhs/local-authority",
    dataControllerId: "166d2b1e-e78f-42f9-9662-5d62bbb10895",
    managingOrganisationId: null,
    status: "active",
};
export const dataControllerNorthConfiguration = {
    id: dataControllerNorth.id,
    configuration: {
        nhsNumberEnabled: true,
        rioInstancesEnabled: [
            {
                instanceId: brazilNorthTrust.id,
                displayName: brazilNorthTrust.externalSystemName,
            },
        ],
    },
};
export const dataControllerCentral = {
    id: "232436d8-2b8d-4d3e-a611-3021dcd3bb86",
    name: "Data Controller Central",
    address: "1 Royal Street",
    postalCode: "SE1 9RT",
    isTrainingOrganisation: false,
    codes: [],
    role: "nhs/local-authority",
    dataControllerId: "232436d8-2b8d-4d3e-a611-3021dcd3bb86",
    managingOrganisationId: null,
    status: "active",
};
export const dataControllerCentralConfiguration = {
    id: dataControllerCentral.id,
    configuration: {
        nhsNumberEnabled: true,
        rioInstancesEnabled: [],
    },
};
export const dataControllerSouth = {
    id: "36fac204-f22d-4531-a80e-52be3fc9f1f1",
    name: "Data Controller South",
    address: "1 Royal Street",
    postalCode: "SE1 9RT",
    isTrainingOrganisation: false,
    codes: [],
    role: "nhs/local-authority",
    dataControllerId: "36fac204-f22d-4531-a80e-52be3fc9f1f1",
    managingOrganisationId: null,
    status: "active",
};
export const dataControllerSouthConfiguration = {
    id: dataControllerSouth.id,
    configuration: {
        nhsNumberEnabled: true,
        rioInstancesEnabled: [
            {
                instanceId: brazilSouthTrust.id,
                displayName: brazilSouthTrust.externalSystemName,
            },
        ],
    },
};
const defaultHospitals = [
    // SLAM
    maudsleyHospital,
    bethlemHospital,
    lambethHospital,
    // G&T
    guysHospital,
    stThomasHospital,
    royalBromptonHospital,
    harefieldHospital,
    // Kings
    kingsCollegeHospital,
    orpingtonHospital,
    princessRoyalHospital,
    // Lewisham and Greenwich
    universityHospitalLewisham,
    queenElizabethHospital,
    // Oxleas
    oxleasHouse,
    elthamHospital,
    erithHospital,
    bridgewaysDayHospital,
    memorialHospital,
    // Training
    trainingHospital,
    trainingLa,
    // NHS Dashboard
    nhsDashboardOrg,
    // Superset Dashboard
    supersetDashboardOrg,
];
export const defaultOrganisations = [
    cqc,
    cqcTraining,
    nhsLondon,
    ...defaultIcbs,
    ...defaultLocalAuthorities,
    ...defaultTrusts,
    ...defaultHospitals,
    bobIndependentOrg,
    independentDoctorOrg1,
    independentDoctorOrg2,
    independentDoctorOrg3,
    independentDoctorOrg4,
    independentDoctorOrg5,
    independentDoctorOrg6,
    independentDoctorOrg7,
    independentDoctorOrg8,
    independentDoctorOrg9,
    independentDoctorOrg10,
    independentDoctorOrg11,
    independentDoctorOrg12,
    independentDoctorOrg13,
    independentDoctorOrg14,
    independentDoctorOrg15,
    acdFacilitatorIndependentOrg,
    dataControllerNorth,
    dataControllerCentral,
    dataControllerSouth,
    soad1IndependentOrg,
    soad2IndependentOrg,
    trainingIsabellaSoadOrg,
    leadingEdgeIcb,
    leadingEdgeTrust,
    leadingEdgeTrustTwo,
    leadingEdgeHospital,
    leadingEdgeLocalAuthority,
    trailingEdgeIcb,
    trailingEdgeTrust,
    trailingEdgeHospital,
    trailingEdgeLocalAuthority,
    ...elysiumOrganisations,
];
export const defaultOrganisationConfigurations = [
    cqcConfiguration,
    cqcTrainingConfiguration,
    bobIndependentOrgConfiguration,
    independentDoctorOrg1Configuration,
    independentDoctorOrg2Configuration,
    independentDoctorOrg3Configuration,
    independentDoctorOrg4Configuration,
    independentDoctorOrg5Configuration,
    independentDoctorOrg6Configuration,
    independentDoctorOrg7Configuration,
    independentDoctorOrg8Configuration,
    independentDoctorOrg9Configuration,
    independentDoctorOrg10Configuration,
    independentDoctorOrg11Configuration,
    independentDoctorOrg12Configuration,
    independentDoctorOrg13Configuration,
    independentDoctorOrg14Configuration,
    independentDoctorOrg15Configuration,
    acdFacilitatorIndependentOrgConfiguration,
    slamDefaultOrgConfiguration,
    dataControllerNorthConfiguration,
    dataControllerCentralConfiguration,
    dataControllerSouthConfiguration,
    leadingEdgeIcbConfiguration,
    leadingEdgeTrustConfiguration,
    leadingEdgeTrustTwoConfiguration,
    trailingEdgeIcbConfiguration,
    supersetDashboardOrgConfiguration,
    ...elysiumOrganisationConfigurations,
];
//# sourceMappingURL=organisations.js.map